module.exports = __webpack_public_path__ + "static/media/dvd-list04.376486a0.jpg";